export enum DatasheetComponentTextStyle {
  bold = 1,
  italic = 2,
  underline = 3,
}